import { cx } from '@linaria/core';
import { memo, ReactNode, Ref } from 'react';
import { MYML_LOCATIONS } from '../../../constants/enums';
import Recommendations from '../YouMayLike/embedded/Recommendation';
import "./Poster.linaria.module.css!=!./Poster?./Poster.linaria.module.css?css=H4sIAAAAAAAAA2XRy26DMBAF0H2/IstWClFNHiD6MRaPwRjMDIVJoFj996pJ0zBkeeV7DNbdpdzqTmNERVz7FG2bsiVMzjgAf3y/7H7PI6cNTVUHPidHfdKb7PV42m7UIdxuTu9v954jrTg39dGsou/SorBoAqYuCQ/d9C9ACngSGTFTK1EjUfOEHJQsiZPEPZHemkqafq9VdaL6PHuGiYPUWYNJDsjQ3zt5rNXQVGlNq+hLQg4GO0Oi1OPOfNAx7lWYyXRrj3D9h4xcce+bvVblOOEFVtE7ixBUN6HCxxfGT91kEV5mPwcWC5gStZiHopQMyyTGUUcxzrIP6/7fNII0gjRrch1GACeAW4PbLEtx+dKqGSNsD360BVeJxQp6y4tXlmysC2USr4yv1/0AfKaTGvwCAAA="
const staticStyles = "atm_p_n7od8j atm_7l_goxhpe atm_lo_1tcgj5g atm_le_1tcgj5g atm_lk_1tcgj5g atm_ll_1tcgj5g atm_r3_1h6ojuz atm_c8_1skhajo atm_cs_8n312b atm_g3_1fwxnve atm_wq_kb7nvz";
const compactStyles = "atm_lo_o7aogt atm_le_o7aogt atm_lk_o7aogt atm_ll_o7aogt";
type PosterProps = {
  ref?: Ref<HTMLDivElement>;
  children?: ReactNode;
  compact?: boolean;
  hiddenShow?: boolean;
  styleOverrides?: string;
  isOffline?: boolean;
  showRecommendations?: boolean;
  modelId?: number;
};
const embedModelStyles = "atm_vy_1kw7nm4 atm_lo_ftgil2";
const Poster = memo((props: PosterProps) => {
  const {
    ref,
    children,
    compact,
    hiddenShow,
    isOffline,
    modelId,
    showRecommendations,
    styleOverrides
  } = props;
  const embedModelsYouMayLike = isOffline && showRecommendations;
  const styles = cx(staticStyles, compact && compactStyles, styleOverrides, embedModelsYouMayLike && embedModelStyles);
  const testId = `Image__Model${hiddenShow ? 'Show' : ''}Status`;
  return <div ref={ref} data-testid={testId} className={styles}>
            {children}
            {embedModelsYouMayLike && <div data-testid="Offline__Recommendations">
                    <Recommendations id={modelId} inRoomOrProfile showAsGrid hideNoResultNotice={true} location={MYML_LOCATIONS.room} />
                </div>}
        </div>;
});
export default Poster;